import type { PatientStatus } from "@/server/types/patient-status";
import {
  NEEDS_ATTENTION_PRESENTATION,
  PATIENT_STATUS_PRESENTATION,
  type StatusPresentation,
} from "@/frontend/types/dashboard/patient-status";

/** Resolves the badge to render for one row, attention overlay first. */
export function patientStatusPresentation(
  status: PatientStatus,
  needsAttention: boolean,
): StatusPresentation {
  return needsAttention ? NEEDS_ATTENTION_PRESENTATION : PATIENT_STATUS_PRESENTATION[status];
}

/**
 * The last-sync cell. A patient mid-pull reads "Syncing now" rather than a
 * timestamp, and one who has never been invited reads as an em dash — a date
 * there would imply a sync that never happened.
 */
export function lastSyncLabel(
  status: PatientStatus,
  lastActivityAt: Date | null,
  formatted: string,
): string {
  if (status === "syncing") return "Syncing now";
  if (status === "added") return "—";
  if (!lastActivityAt) return "—";
  if (status === "invited") return `Link generated ${formatted}`;
  return formatted;
}
